import type { UserRole } from "./types";

/**
 * Roles that `admin` stands in for.
 *
 * `admin` is a composite: it satisfies any check written for one of the
 * specialist roles. Every new specialist role has to be added here, or every
 * check guarded by it silently refuses admins — this list, the server's
 * `requireRole` middleware, and the portal's nav gating all read from here
 * so the three can't drift apart (D12 item 1).
 */
export const ADMIN_COMPOSITE_ROLES: UserRole[] = [
  "content_editor",
  "scholarship_reviewer",
  "empowerment_reviewer",
];

/** Whether `actualRole` satisfies a check written for `requiredRoles`. */
export function roleSatisfies(requiredRoles: UserRole[], actualRole: UserRole): boolean {
  if (requiredRoles.includes(actualRole)) return true;
  return (
    actualRole === "admin" &&
    requiredRoles.some((role) => ADMIN_COMPOSITE_ROLES.includes(role))
  );
}
